module.exports = {"140427100":"龙泉镇","140427101":"百尺镇","140427102":"店上镇","140427103":"晋庄镇","140427104":"树掌镇","140427105":"大峡谷镇","140427106":"集店镇","140427201":"黄山乡","140427202":"东井岭乡","140427203":"石坡乡","140427401":"壶关县经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140427.json
// module id = 388
// module chunks = 0